import { Cookie } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ConsentBannerProps {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onOpenPreferences: () => void;
}

export default function ConsentBanner({
  onAcceptAll,
  onRejectAll,
  onOpenPreferences,
}: ConsentBannerProps) {
  return (
    <section
      className="fixed inset-x-3 bottom-[calc(env(safe-area-inset-bottom)+0.75rem)] z-50 mx-auto max-w-5xl rounded-[24px] border border-[#d8e6de] bg-white/95 p-4 shadow-[0_24px_70px_-38px_rgba(11,23,17,0.55)] backdrop-blur sm:p-5"
      role="region"
      aria-label="Preferencias de privacidade"
    >
      <div className="grid gap-4 lg:grid-cols-[1fr_auto] lg:items-center">
        <div className="flex gap-3">
          <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#dcfce7] text-[#16783a]">
            <Cookie className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-black tracking-[-0.02em] text-[#102018]">
              Preferencias de privacidade
            </p>
            <p className="mt-1 text-sm leading-6 text-[#53645b]">
              Usamos cookies e tecnologias semelhantes para manter sua sessão, melhorar o app,
              medir uso e corrigir erros. Alguns são essenciais para o funcionamento; outros nos
              ajudam a entender como o app é usado. Você pode aceitar todos ou escolher quais
              categorias ativar.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row lg:justify-end">
          <Button type="button" variant="outline" className="border-[#9fceb3]" onClick={onRejectAll}>
            Usar apenas essenciais
          </Button>
          <Button type="button" variant="secondary" onClick={onOpenPreferences}>
            Gerenciar preferências
          </Button>
          <Button type="button" variant="outline" className="border-[#9fceb3]" onClick={onAcceptAll}>
            Aceitar todos
          </Button>
        </div>
      </div>
    </section>
  );
}
